import { useFormHandlers } from "@/hooks";
import cn from "classnames";
import { createForm, formShape } from "rc-form";
import React, { FC, FormEvent } from "react";
import { Element } from "react-scroll";

import Button from "@/apps/ui/components/Button";
import Input from "@/apps/ui/components/Input";
import ReduxApiMiddlewareError from "@/apps/ui/components/ReduxApiMiddlewareError";

import { LoadPartsType, SaveQueryType } from "../../store/parts/actions";
import { ReduxApiMiddlewareErrorType } from "../../store/parts/types";

import styleCss from "./style.css";

interface FormProps {
  form: any;
  loading: boolean;
  error?: ReduxApiMiddlewareErrorType;
  loadParts: LoadPartsType;
  saveQuery: SaveQueryType;
}

const Form: FC<FormProps> = function ({
  form: { getFieldDecorator, validateFields, getFieldError },
  error,
  loading,
  loadParts,
  saveQuery,
}) {
  function submit(values: any) {
    saveQuery(values.id);

    if (!loading) {
      loadParts(values.id);
    }
  }

  const { onSubmit, getError } = useFormHandlers({
    form: { getFieldError, validateFields },
    submitAction: submit,
  });

  return (
    <div className="mb-4">
      <Element className="scroll-to-anchor" name="part-price-form" />
      <form className={styleCss.form} onSubmit={onSubmit}>
        {getFieldDecorator("id", {
          rules: [
            { required: true, message: "Заполните поле" },
            { min: 3, message: "Введите значение не менее 3х символов" },
          ],
          initialValue: "",
        })(<Input placeholder="Например, M9360-86CB0-000" className={styleCss.search} error={getError("id")} />)}
        <Button type="submit" icon="arrow" className={cn(styleCss["btn-primary-service"])} disabled={loading}>
          Найти
        </Button>
      </form>
      {error && (
        <div className="mt-2">
          <ReduxApiMiddlewareError error={error} />
        </div>
      )}
    </div>
  );
};

Form.propTypes = {
  form: formShape,
};

export default createForm()(Form);
